var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-bar',{attrs:{"title-stack":_vm.titleStack}}),_c('section',{staticClass:"section is-main-section"},[_c('finance-metrics',{staticClass:"mb-5"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }